/* Shared agent settings/details layout, extracted for the touched-file strict gate. */
.sectionSpacing {
  margin-bottom: 16px;
}
.labelSpacing {
  margin-bottom: 12px;
}
.emptyHint {
  color: var(--text-tertiary);
  margin-top: 12px;
}
.retrievalRow {
  padding: 16px 0;
}
.checkboxAlign {
  flex-shrink: 0;
  margin-top: 3px;
}
.helpSpacing.helpSpacing {
  margin-top: 4px;
}
.noMargin {
  margin-bottom: 0;
}
.stack {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.destinationPill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: var(--light-gray);
  border-radius: 8px;
  min-height: 36px;
}
.mutedLabel {
  color: var(--text-tertiary);
  font-size: 14px;
}
.bodyText {
  font-size: 14px;
}
.compactRow {
  display: flex;
  align-items: center;
  gap: 6px;
}
.optionIcon {
  display: inline-flex;
  flex-shrink: 0;
}
.optionName {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.footerHint {
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 0;
}
.textLink {
  text-decoration: underline;
  color: inherit;
}
.loading {
  text-align: center;
  padding: 20px;
}
.emptyState {
  color: var(--text-tertiary);
  padding: 20px;
}
.row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.countryPicker.countryPicker {
  width: auto;
  flex-shrink: 0;
  line-height: 0;
}
.inlineFlag {
  display: inline-block;
}
.hidden {
  display: none;
}
.preLine {
  white-space: pre-line;
}
.noTopPadding.noTopPadding {
  padding-top: 0;
}
.phoneRow {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.grow {
  flex: 1;
}
.extension {
  width: 100px;
}
.hiddenLabel {
  visibility: hidden;
}
.menu {
  margin-bottom: 24px;
}
.menuHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.menuBody {
  border-left: 2px solid var(--light-gray);
  padding-left: 20px;
}
.menuLabel {
  font-weight: 600;
  margin-bottom: 4px;
}
.menuRow {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) 24px;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.menuKey.menuKey {
  height: 36px;
  background: var(--light-gray);
  border-radius: 8px;
}
.menuOption.menuOption {
  height: 36px;
  background: var(--light-gray);
  border-color: transparent;
  border-radius: 8px;
}
.menuDelete.menuDelete {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 32px;
  padding: 0;
  color: var(--text-primary);
}
.menuError {
  color: var(--error, #d92d20);
  margin: -2px 0 6px;
}
.menuField {
  margin-top: 12px;
}
.menuField label {
  display: block;
  font-weight: 600;
  margin-bottom: 4px;
}
.menuRepeatKey.menuRepeatKey {
  width: 56px;
  height: 36px;
  border-radius: 8px;
  text-align: center;
}
.menuHint {
  color: var(--text-secondary);
  margin-top: 8px;
}
